<div *ngrxLet="mapViewModel$; let value" class="flex flex-col grow relative">
  <div class="w-full h-full">

    <google-map
        class="h-full w-full"
        height="inherit"
        width="inherit"
        [options]="MAP_OPTIONS"
        (mapClick)="closeInfoWindow()"
        (boundsChanged)="updateMapLoading(true)"
        (idle)="updateMapLoading(false)">

        <!--    Default, CC    -->

      <map-marker-clusterer [styles]="CLUSTER_ICON_STYLES"
                            [batchSize]="35000"
                            [maxZoom]="17"
                            #cluster>
        @for (marker of (delayedAndFilteredMarkers$ | ngrxPush); track trackByFn($index, marker)) {
          <!-- Markers -->
          <map-marker #markerElem="mapMarker"
                      #mapMarkers
                      [position]="marker.position"
                      [options]="marker.options"
                      [label]="marker.options.label"
                      (mapClick)="openInfoWindow(markerElem, marker)"
                      (mapMouseover)="onMouseover($event, value.focusedLocation?.id, marker, value.ccRowSettings)"
                      (mapMouseout)="onMouseout(value.focusedLocation?.id, marker, value.ccRowSettings)"
                      (mapDblclick)="scrollGridRowIntoView(isDefaultMarker(marker) ? marker.markerLocations[0] : undefined)"/>
          <!-- Circle -->
          @if (showCircle(marker, value.isCcOn, value.focusedLocation)) {
            <map-circle
                [center]="marker.position"
                [radius]="value.ccRadius"
                [options]="CIRCLE_OPTIONS"></map-circle>
          }
        }
      </map-marker-clusterer>

      <!-- Info Window -->
        <map-info-window>
          <app-info-window-content (scrollGridRowIntoView)="scrollGridRowIntoView($event)"
                                   (highlightGridRow)="highlightGridRow(value.focusedLocation?.id, $event, value.ccRowSettings)"
                                   (removeHighlightFromGridRow)="removeHighlightFromGridRow(value.focusedLocation?.id, $event, value.ccRowSettings)"
                                   [viewModel$]="infoWindowViewModel$"/>
        </map-info-window>
      </google-map>

  </div>

</div>

<!--marker tooltip-->
<div *ngrxLet="markerTooltipViewModel$; let value;"
     [style.left.px]="value.tooltipX"
     [style.top.px]="value.tooltipY"
     [style.display]="value.hoveredMarker && isDefaultMarker(value.hoveredMarker) ?
      '' : 'none'"
     class="absolute p-2 bg-neutral-30 text-white rounded text-[11px]"
     [innerHTML]="value.hoveredMarker | tooltipText"></div>

<div class="absolute top-[8px] left-[8px]">
  <app-map-ui [googleMap]="googleMap"
              [cvButtonActive]="cvButtonActive()"
              [markersMinimized]="markersMinimized()"
              [rightPanelWidth]="rightPanelWidth()"
              (toggleCvMode)="onToggleCvMode()"
              (toggleMinimizeMarkers)="onToggleMinimizeMarkers()"
              (placeAutocompleteMarker)="onPlaceAutocompleteMarker($event)"></app-map-ui>
</div>
